import { FC, useContext, useEffect, useRef, useState } from 'react';
import { Link } from '@marriott/mi-ui-library';
import { LocalHeaderAccuWeather } from './LocalHeaderAccuWeather';
import { LocalHeaderNavigationProps } from '../LocalHeader.types';
import {
  localOffersContentID,
  merchandisingContentID,
  merchandisingLuxuryBrand,
} from '../../../modules/utils/constants/constants';
import { serviceStore, useServiceStore } from '../../../modules/store/serviceStore';
import { PageParamsContext } from '../../../modules/context/PageContext';

export const LocalHeaderNavigation: FC<LocalHeaderNavigationProps> = pageProps => {
  const { navigationAttributes, localHeaderNavigationRef, linkClicked } = pageProps;
  const [l2NavLinks, setL2NavLinks] = useState<JSX.Element[]>([]);
  const listRefStickyNavLinksRef = useRef<NodeListOf<HTMLElement> | null>(null);
  const [isLuxuriousBrand, setIsLuxuriousBrand] = useState<boolean>(false);
  const serviceData = useServiceStore((state: serviceStore) => state.serviceData);
  const linkedTargetElements: Array<{
    targetElement: Element | null;
    linkElement: null;
  }> = [];

  const { preProcessorResponse } = useContext(PageParamsContext);
  const { brandCode } = preProcessorResponse ?? {};

  const handleLinkClick = (event: { target: { hash: string }; preventDefault: () => void }) => {
    linkClicked(event);
  };

  useEffect(() => {
    if (brandCode && merchandisingLuxuryBrand.includes(brandCode)) {
      setIsLuxuriousBrand(true);
    }
  }, [brandCode]);

  useEffect(() => {
    listRefStickyNavLinksRef.current = document.querySelectorAll('.local-header__menu-bottom-link');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    listRefStickyNavLinksRef.current.forEach((link: any) => {
      linkedTargetElements.push({
        targetElement: document.querySelector(`[id="${link.hash.substr(1)}"]`),
        linkElement: link,
      });
      link.addEventListener('click', handleLinkClick, link);
    });
  }, [l2NavLinks]);

  useEffect(() => {
    let links: JSX.Element[] = [];
    navigationAttributes &&
      navigationAttributes?.forEach((navigation, index) => {
        if (document.getElementById(navigation.componentId)) {
          //to hide merchandising component
          if (!(isLuxuriousBrand && navigation.componentId === merchandisingContentID)) {
            //to hide Nearby Things To Do component
            if (
              navigation.componentId !== localOffersContentID ||
              (navigation.componentId === localOffersContentID && document.querySelector('.app-js__nearby-outlet'))
            )
              links = [
                ...links,
                <li key={`${navigation.componentId}-${index}`} className="py-0 mr-3 pr-3 my-2">
                  <Link
                    linkHref={`#${navigation.componentId}`}
                    linkClassName="t-font-s pt-0 mr-0 mr-md-1 local-header__menu-bottom-link links mb-1"
                  >
                    {navigation?.label}
                  </Link>
                </li>,
              ];
          }
        }
      });
    setL2NavLinks(links);
  }, [serviceData?.servicesLoaded, isLuxuriousBrand, navigationAttributes]);

  return (
    <div
      className="local-header__menu-bottom d-flex flex-wrap justify-content-between col-12 p-0"
      ref={localHeaderNavigationRef}
      data-testid="local-header__menu-bottom_test"
    >
      <div className="local-header__menu-bottom-container flex-wrap col-12 p-0">
        <ul
          className={`local-header__menu-bottom-list d-flex my-2 pl-3 pl-md-0 justify-content-md-center ${
            l2NavLinks.length <= 2 ? 'justify-content-center' : ''
          }`}
        >
          {l2NavLinks}
        </ul>
      </div>
      <div
        className="accu-weather-fragment container rendered"
        data-id="headerAccuweather"
        id="headerAccuweather"
        data-compid="headerAccuweather"
      >
        <LocalHeaderAccuWeather {...pageProps} />
      </div>
    </div>
  );
};
